import baseshapePriceData from './baseshape-price-data';
import checkout from './checkout';
import shoppingcart from './shoppingcart';

export default {
  ...baseshapePriceData,
  ...checkout,
  ...shoppingcart
};
